export { EcoLogo1 } from "./EcoLogo1";
